import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useRouter } from 'next/router';
import { Selectors } from '@grandvisionhq/auth';
import { MediaQuery, Logo, Alert, SupportFooter } from '@grandvisionhq/common';
import { SplitPane } from '@grandvisionhq/layout';
import { useIntl, useStore, useSelector } from '@grandvisionhq/state';
import { useGetQueryParams, appendQueryParamToUrl } from '@grandvisionhq/utils';
import { getSelectedShippingMethod } from '../StepShipping/selectors.js';
import { StepNames } from '../models/shared.js';
import { NavigationContainer } from '../modules/Navigation/NavigationContainer.js';
import { useCheckoutSettings } from '../context/CheckoutSettings/context.js';

const CheckoutLayout = ({ showNavigation , logo , status , currentStep , pageRouteRoot , leftContentSection , cartContentSection  })=>{
    const isOverviewStep = currentStep === StepNames.Overview;
    const isShippingStep = currentStep === StepNames.Shipping;
    const { cartId , cartHash  } = useGetQueryParams();
    const { getLabel  } = useIntl();
    const router = useRouter();
    const headerRef = React.useRef(null);
    const store = useStore();
    const isLoggedIn = Selectors.isLoggedIn(store.getState());
    const currentBreakpoint = MediaQuery.useBreakpoint();
    const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    const { routes  } = useCheckoutSettings();
    React.useEffect(()=>{
        headerRef.current && headerRef.current.scrollIntoView();
    }, []);
    /**
   * navigation handler for steps
   * @param path
   *
   */ const onNavigationClick = (path)=>{
        var ref;
        let routePath = (ref = routes[path]) === null || ref === void 0 ? void 0 : ref.path;
        if (routePath) {
            routePath = appendQueryParamToUrl(routePath, swcHelpers.objectSpread({}, typeof cartId === 'string' ? {
                cartId
            } : {}, typeof cartHash === 'string' ? {
                cartHash
            } : {}));
            router === null || router === void 0 ? void 0 : router.push(routePath);
        }
    };
    /**
   *  check status of payment through
   *  url query params
   */ const isFailedCheckoutStep = React.useMemo(()=>{
        return status === 'failed' ? true : false;
    }, [
        status
    ]);
    return /*#__PURE__*/ React.createElement(SplitPane, {
        main: /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section checkout-section--main"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__header",
            ref: headerRef
        }, /*#__PURE__*/ React.createElement(Logo, {
            url: pageRouteRoot,
            image: logo
        }), showNavigation && /*#__PURE__*/ React.createElement(NavigationContainer, {
            currentStep: currentStep,
            onNavigate: onNavigationClick,
            isLoggedIn: isLoggedIn
        })), isMobile && !isOverviewStep && /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__cart"
        }, cartContentSection), /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__body"
        }, isFailedCheckoutStep && /*#__PURE__*/ React.createElement(Alert, {
            className: "checkout-section__alert",
            type: "error",
            title: getLabel('checkout.errors.general.title'),
            message: getLabel('checkout.errors.general.message')
        }), !(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isValid) && (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isTouched) && isShippingStep && /*#__PURE__*/ React.createElement(Alert, {
            className: "checkout-section__alert",
            type: "warning",
            icon: "warning",
            title: getLabel('checkout.warning.invalid.delivery.title'),
            message: getLabel('checkout.warning.invalid.delivery.message')
        }), leftContentSection)),
        aside: /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section checkout-section--aside"
        }, !isMobile && /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__cart"
        }, cartContentSection ? cartContentSection : null), /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__support-footer"
        }, /*#__PURE__*/ React.createElement(SupportFooter, {
            message: getLabel('support.title'),
            phoneNumber: getLabel('support.phoneNumber', {
                hideLabelKey: true
            }) || undefined,
            email: getLabel('support.emailAddress', {
                hideLabelKey: true
            }) || undefined
        })))
    });
};

export { CheckoutLayout };
//# sourceMappingURL=CheckoutLayout.js.map
